import React from 'react';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { SelectionCard } from './SelectionCard';

interface ManualCreateSelectionCardProps {
  onClick: () => void;
}

export const ManualCreateSelectionCard = ({ onClick }: ManualCreateSelectionCardProps) => {
  return (
    <SelectionCard
      title="Manual Create"
      description="Start from scratch with full control."
      icon={faEdit}
      iconColor="#4a69bd"
      iconBackgroundColor="#dde7ff"
      onClick={onClick}
    />
  );
};
